export type PeriodApiEnum =
  | 'Last7Days'
  | 'Last14Days'
  | 'Last30Days'
  | 'Last60Days'
  | 'ThisMonth'
  | 'PreviousMonth'
  | 'LastWeek'
  | 'CurrentWeek'
  | 'AllTime';

export enum PeriodType {
  LAST_7_DAY = 0,
  LAST_14_DAY = 1,
  LAST_30_DAY = 2,
  LAST_60_DAY = 3,
  THIS_MONTH = 4,
  PREVIOUS_MONTH = 5,
  CURRENT_WEEK = 6,
  lAST_WEEK = 7,
  ALL_TIME = 8,
}

export interface PeriodItem {
  label: string;
  value: PeriodType;
}

export interface PeriodGroupItem {
  label: string;
  items: PeriodItem[];
}

export const TimePeriodOptions: PeriodGroupItem[] = [
  {
    label: 'Periods',
    items: [
      { label: 'Last 7 days', value: PeriodType.LAST_7_DAY },
      { label: 'Last 14 days', value: PeriodType.LAST_14_DAY },
      { label: 'Last 30 days', value: PeriodType.LAST_30_DAY },
      { label: 'Last 60 days', value: PeriodType.LAST_60_DAY },
      { label: 'Current week', value: PeriodType.CURRENT_WEEK },
      { label: 'Last week', value: PeriodType.lAST_WEEK },
    ],
  },
  {
    label: 'Other Periods',
    items: [
      { label: 'This month', value: PeriodType.THIS_MONTH },
      { label: 'Previous month', value: PeriodType.PREVIOUS_MONTH },
      { label: 'All time', value: PeriodType.ALL_TIME },
    ],
  },
  // {
  //   label: 'Custom',
  //   items: [{ label: 'Choose custom date', value: PeriodType.CUSTOM }],
  // },
];
